import { ScanToPayContainer } from './ScanToPayContainer';
import { ScanToPayBottomCard } from './ScanToPayBottomCard';
import { ScanToPayCreditBalance } from './ScanToPayCreditBalance';
import { ScanToPayPaymentMethod } from './ScanToPayPaymentMethod';
import { ScanToPayPaymentSelectionModal } from './ScanToPayPaymentSelectionModal';
import { ScanToPayLoadingState } from './ScanToPayLoadingState';
import { ScanToPayEmptyState } from './ScanToPayEmptyState';
import { ScanToPayErrorState } from './ScanToPayErrorState';
import { ScanToPayFooter } from './ScanToPayFooter';
import { ScanToPayTabsContainer } from './ScanToPayTabsContainer';
import { ScanToPayTabsHeader } from './ScanToPayTabsHeader';
import { ScanToPayTab } from './ScanToPayTab';
import { ScanToPayPointsCta } from './ScanToPayPointsCta';
import { ScanToPayPointsModal } from './ScanToPayPointsModal';
import { ScanToPayFaqCta } from './ScanToPayFaqCta';
import { ScanToPayFaqModal } from './ScanToPayFaqModal';
import { ScanToPayQrCode } from './ScanToPayQrCode';

export const ScanToPay = {
  TabsContainer: ScanToPayTabsContainer,
  TabsHeader: ScanToPayTabsHeader,
  Tab: ScanToPayTab,

  Container: ScanToPayContainer,
  Footer: ScanToPayFooter,

  BottomCard: ScanToPayBottomCard,
  CreditBalance: ScanToPayCreditBalance,

  PaymentMethod: ScanToPayPaymentMethod,
  PaymentSelectionModal: ScanToPayPaymentSelectionModal,

  FaqCta: ScanToPayFaqCta,
  FaqModal: ScanToPayFaqModal,

  PointsCta: ScanToPayPointsCta,
  PointsModal: ScanToPayPointsModal,

  QrCode: ScanToPayQrCode,

  LoadingState: ScanToPayLoadingState,
  EmptyState: ScanToPayEmptyState,
  ErrorState: ScanToPayErrorState,
};
